import { useState, useSyncExternalStore } from "react"

import { useEffectiveTheme, type EffectiveTheme } from "./use-effective-theme"

function subscribe(onChange: () => void) {
  document.addEventListener("visibilitychange", onChange)
  return () => document.removeEventListener("visibilitychange", onChange)
}

const getSnapshot = () => document.visibilityState !== "hidden"
const getServerSnapshot = () => true

/**
 * The effective theme, held at its last visible value while the document is
 * hidden. iPadOS snapshots a backgrounded app in both light and dark for the
 * app switcher, which flips `prefers-color-scheme` behind the user's back.
 * Consumers that pay for a theme change (a Google Map is rebuilt for a new
 * `colorScheme`) only see the theme the user actually comes back to.
 */
export function useVisibleEffectiveTheme(): EffectiveTheme {
  const theme = useEffectiveTheme()
  const visible = useSyncExternalStore(
    subscribe,
    getSnapshot,
    getServerSnapshot
  )
  const [heldTheme, setHeldTheme] = useState(theme)

  if (visible && heldTheme !== theme) {
    setHeldTheme(theme)
  }

  return visible ? theme : heldTheme
}
